<template>
    <div class="video-container">
        <video ref="videoRef" preload="auto" id="video" src="" autoplay>
            <p>Video not compatible</p>
        </video>
    </div>
</template>

<script>
export default {
    name: "video-container",
    props: ['clip', 'nextRoute'],
    mounted() {
        let video = document.querySelector('#video')
        this.$refs.videoRef.src = this.clip;

        var playPromise = this.$refs.videoRef.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                // eslint-disable-next-line
                console.log("playing")
            })
            .catch(error => {
                // eslint-disable-next-line
                console.log(error)
            });
        }

        video.addEventListener('ended', () => {
            this.$router.push({ path: this.nextRoute })
        })
    }
}
</script>

<style lang="scss" scoped>
#video {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>
